import { DatePipe } from "@angular/common";
import { Component, HostListener, Input, ViewChild } from "@angular/core";
import { BucketsService } from "src/app/core/services/buckets.service";
import { CitaService } from "src/app/core/services/cita.service";
import { CitasPagosService } from "src/app/core/services/citas-pagos.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { PaymentFormComponent } from "../../payment-form/payment-form.component";
import { SpanishDatePipe } from "./spanishDate.pipe";
import { Router } from "@angular/router";
import { CommonModule } from "@angular/common";
import { PaquetesAdquiridosService } from "src/app/core/services/paquetes-adquiridos.service";
import { MisPaquetesComponent } from "../../paquetes/mis-paquetes/mis-paquetes.component";

@Component({
  selector: "app-proximas-citas",
  standalone: true,
  imports: [DatePipe, PaymentFormComponent, SpanishDatePipe, CommonModule],
  templateUrl: "./proximas-citas.component.html",
  styleUrl: "./proximas-citas.component.scss",
})
export class ProximasCitasComponent {
  @ViewChild(PaymentFormComponent) paymentFormComponent: PaymentFormComponent;

  @Input() misPaquetesRef!: MisPaquetesComponent;

  listadoCitas: any;
  cargandoCitas = true;
  currentUser: any;
  private BUCKET_FOTOS_ESPECIALISTAS = environment.bucketFotosEspecialistas;

  isMobile = false;

  constructor(
    private __citaService: CitaService,
    private __bucketService: BucketsService,
    private __citasPagosService: CitasPagosService,
    private __paquetesAdquiridosService: PaquetesAdquiridosService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.checkIfMobile();

    const currentUser = localStorage.getItem("currentPatient");
    if (currentUser) {
      this.currentUser = JSON.parse(currentUser);
    }

    this.getCitas(this.currentUser.userId);
  }

  // OBTENER LAS CITAS DE UN PACIENTE
  async getCitas(idPaciente: string) {
    this.cargandoCitas = true;
    const listadoCitas: any = await this.__citaService.getDocumentsbyPaciente(
      idPaciente
    );

    // Filtrar citas por estados permitidos
    const estadosPermitidos = ['agendada', 'confirmada', 'poriniciar', 'iniciada'];
    const citasFiltradas = listadoCitas.filter(cita =>
      estadosPermitidos.includes(cita.idEstadoCita.$id)
    );
    // Crear un array de promesas para ejecutar todas las operaciones en paralelo
    const citasConPagoYFoto = await Promise.all(
      citasFiltradas.map(async (cita: any) => {
        // console.log("CITA::", cita);
        if (cita.IdEstadoPago === "paquete") {
          const fotoUrl = await this.__bucketService.getBucket(
            this.BUCKET_FOTOS_ESPECIALISTAS,
            cita.idEspecialista.foto
          );

          cita.idEspecialista.foto = fotoUrl;
          cita.pagoCita = "paquete";
          return cita;
        }

        const [pagoCita, fotoUrl] = await Promise.all([
          this.__citasPagosService.getDataByCita(cita.$id),
          this.__bucketService.getBucket(
            this.BUCKET_FOTOS_ESPECIALISTAS,
            cita.idEspecialista.foto
          ),
        ]);

        cita.pagoCita = pagoCita[0];
        cita.idEspecialista.foto = fotoUrl;

        return cita;
      })
    );

    this.listadoCitas = citasConPagoYFoto;
    this.cargandoCitas = false;
  }

  /**
   * Cambia el estado de la cita a confirmada
   * @param cita
   */
  confirmarCita(cita: any) {
    cita = {
      $id: cita.$id,
      idEstadoCita: "confirmada",
    };

    this.__citaService
      .changeEstadoCita(cita)
      .then((response) => {
        this.getCitas(this.currentUser.userId);
        Swal.fire(
          "Cita Confirmada",
          "La cita ha sido confirmada correctamente",
          "success"
        );
      })
      .catch((error) => {
        console.error("error confirmando la cita", error);
      });
  }

  /**
   * Cambia el estado de la cita a cancelada
   * @param cita
   */
  cancelarCita(cita: any) {
    // VALIDACIÓN DE HORAS ANTES DE REPROGRAMAR UNA CITA
    const horas = this.returnHours(cita.fechaCita);

    if (horas <= 3) {
      Swal.fire(
        "Citas Online",
        "No es posible cancelar tu cita<br>Ten en cuenta que la reprogramación o cancelación debe ser con 4 horas de anticipación, comunícate con el contact center.",
        "warning"
      );
      return;
    }

    Swal.fire({
      title: "¿Esta seguro de cancelar la Cita?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    }).then((result) => {
      if (result.value) {
        const item = {
          $id: cita.$id,
          idEstadoCita: "cancelada",
        };

        this.__citaService
          .changeEstadoCita(item)
          .then((response) => {
            if (cita.IdEstadoPago.$id == "paquete") {
              // Actualiza o devuelve el paquete usado.
              this.__paquetesAdquiridosService.devolverPaquete(
                this.currentUser.userId
              );
            }
            // Después de cancelar exitosamente, actualiza las citas:
            this.getCitas(this.currentUser.userId);
            // Después de cancelar exitosamente, actualiza los paquetes:
            if (this.misPaquetesRef) {
              this.misPaquetesRef.getPaquetesByPaciente(
                this.currentUser.userId
              );
            }

            Swal.fire(
              "Cita Cancelada",
              "La cita ha sido cancelada correctamente",
              "success"
            );
          })
          .catch((error) => {
            console.error("error cancelando la cita", error);
          });
      }
    });
  }

  // FUNCIÓN PARA RESTAR HORAS DE UNA FECHA DE LA FECHA HORA ACTUAL
  // EJ. CUANTAS HORAS FALTAN PARA SU CITA
  returnHours(fecha) {
    // Obtener fecha y hora de la cita
    const fechaCita = new Date(fecha);

    // Obtener dia y hora actual
    const fechaActual = new Date();

    // Calcular la diferencia en milisegundos
    const diferenciaMs = fechaCita.getTime() - fechaActual.getTime();

    // Convertir la diferencia a horas
    return diferenciaMs / (1000 * 60 * 60);
  }

  // Reprogramar Cita
  reprogramarCita(cita: any) {
    const nombreEspecialista = cita.idEspecialista.nombre;

    // VALIDACIÓN DE HORAS ANTES DE REPROGRAMAR UNA CITA
    const horas = this.returnHours(cita.fechaCita);
    if (horas <= 3) {
      Swal.fire(
        "Citas Online",
        "No es posible reprogramar tu cita<br>Ten en cuenta que la reprogramación o cancelación debe ser con 4 horas de anticipación, comunícate con el contact center.",
        "warning"
      );
      return;
    }

    this.mostrarMotivosDeReprogramacion().then((motivoSeleccionado) => {
      if (motivoSeleccionado) {
        // console.log("El usuario seleccionó:", motivoSeleccionado);
        // Aquí puedes agregar más lógica basada en el motivo seleccionado
        const item = {
          $id: cita.$id,
          idEstadoCita: "reprogramada",
          detalle: motivoSeleccionado,
        };

        this.__citaService.changeEstadoCita(item).then((response) => {
          if (cita.IdEstadoPago.$id == "paquete") {
            // Actualiza o devuelve el paquete usado.
            this.__paquetesAdquiridosService.devolverPaquete(
              this.currentUser.userId
            );
          }

          // Después de cancelar exitosamente, actualiza las citas:
          this.getCitas(this.currentUser.userId);
          // Después de cancelar exitosamente, actualiza los paquetes:
          if (this.misPaquetesRef) {
            this.misPaquetesRef.getPaquetesByPaciente(this.currentUser.userId);
          }
          Swal.fire(
            "Cita en estado reprogramada",
            "La cita ha sido reprogramada correctamente, ya puedes volver a agendarla.",
            "success"
          );

          this.router.navigate(["/citas-list"], {
            queryParams: {
              sede: "",
              servicio: "",
              especialidad: "",
              tipoEspecialista: "",
              nombreEspecialista: nombreEspecialista,
            },
          });
        });
      } else {
        // console.log("El usuario canceló la selección");
      }
    });
  }

  // ALERTA SWAL para los motivos de reprogramación
  async mostrarMotivosDeReprogramacion() {
    return await Swal.fire({
      title: "¿Esta seguro de reprogramar la Cita?",
      icon: "warning",
      text: "Seleccione el motivo de por qué quieres reprogramarla",
      input: "select",
      inputOptions: {
        horario: "Conflictos de horario",
        problemas_financieros: "Problemas financieros",
        ansiedad_miedo: "Ansiedad o miedo al tratamiento",
        cambio_seguro: "Cambio en la cobertura del seguro",
        enfermedad: "Enfermedad imprevista",
        transporte: "Problemas de transporte",
        olvido: "Olvido",
      },
      // inputValidator: (value) => {
      //   return new Promise((resolve) => {
      //     if (!value) {
      //       resolve();
      //     } else {
      //       resolve("You need to select oranges :)");
      //     }
      //   });
      // },
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.isConfirmed) {
        // console.log("Motivo seleccionado:", result.value);
        // Aquí puedes agregar la lógica para manejar el motivo seleccionado
        return result.value;
      } else {
        // console.log("Selección cancelada");
        return null;
      }
    });
  }

  /**
   * Cambia el estado de la cita a realizada
   * @param cita
   */
  convertToLocal(date: string | Date): Date {
    const utcDate = new Date(date);
    const localDate = new Date(utcDate.getTime() - -5 * 60 * 60 * 1000); // UTC-5
    return localDate;
  }

  /**
   * realizarPago()
   * @param cita
   */
  async realizarPago(idCita: any, valorCita: any) {
    // console.log("pago valor: ", valorCita);
    const confirm = await Swal.fire({
      title: "¿Sera redirigido para continuar con el proceso de compra?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#f46a6a",
      confirmButtonText: "Confirmar",
      cancelButtonText: "Cancelar",
    });

    if (confirm.value) {
      this.paymentFormComponent.signature = await this.generateHash(
        "c_" + idCita,
        valorCita
      );
      this.paymentFormComponent.amountInCents = valorCita;
      this.paymentFormComponent.reference = "c_" + idCita;
      if (this.paymentFormComponent) {
        this.paymentFormComponent.submitPayment();
      }
    }
  }

  /**
   * generateHash()
   * @param idPago
   * @returns
   */
  async generateHash(idPago: string, valor: number) {
    const cadenaConcatenada =
      idPago + valor * 100 + "COP" + environment.wompi.testIntegrity;
    // console.log(cadenaConcatenada);
    //Ejemplo
    const encondedText = new TextEncoder().encode(cadenaConcatenada);
    const hashBuffer = await crypto.subtle.digest("SHA-256", encondedText);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray
      .map((b) => b.toString(16).padStart(2, "0"))
      .join(""); // "37c8407747e595535433ef8f6a811d853cd943046624a0ec04662b17bbf33bf5"
    return hashHex;
  }

  // VALIDAR SI ES VERSION MOBILE O NO:
  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.checkIfMobile();
  }

  private checkIfMobile() {
    this.isMobile = window.innerWidth < 768;
  }
}
